import services from 'services/services';
import * as types from '../types';
import { setRequestUrl } from 'store/actions';

// Import helpers
import {
	checkFetchErrors,
	queryParams
} from '../helpers_actions/convert_helpers';

// Import variables
import { TABLE_LENGTH } from 'components/helpers/table';

// ******************** FETCH AGREEMENTS - TABLE DATA ********************
export const fetchAgreements = (options) => async (dispatch, getState) => {
	try {
		// Dispatch a loading action
		dispatch({
			type: types.FETCH_AGREEMENTS_LOADING,
			payload: true
		});

		const {
			agreements: {
				table: {
					columns,
					options: {
						filters: { filterUrlQuery },
						startIndex: startTableIndex,
						page
					}
				}
			}
		} = getState();

		const startIndex =
			options.page === page ? startTableIndex : options.startIndex;

		const url = `/agreements/list?${filterUrlQuery}${queryParams(
			options,
			TABLE_LENGTH,
			columns,
			startIndex
		)}`;

		const { data: agreements } = await services.get(url);

		// Calculate pages
		const pages = Math.ceil(agreements.recordsFiltered / TABLE_LENGTH);

		// Dispatch an action with data
		dispatch({
			type: types.FETCH_AGREEMENTS_SUCCESS,
			payload: { ...agreements, pages, page: options.page, startIndex }
		});

		// save request url in redux
		setRequestUrl(url)(dispatch);
	} catch (error) {
		dispatch({
			type: types.FETCH_AGREEMENTS_ERROR,
			payload: checkFetchErrors(error)
		});
	}
};

// ******************** DELETE AGREEMENTS ********************
export const deleteAgreements = (id) => async (dispatch) => {
	try {
		// Dispatch a loading action
		dispatch({
			type: types.DELETE_AGREEMENT_LOADING,
			payload: true
		});

		await services.delete(`/agreements/${id}`);
		// Dispatch an action with data
		dispatch({
			type: types.DELETE_AGREEMENT_SUCCESS,
			payload: true
		});
	} catch (error) {
		// Dispatch an action with error set to true
		dispatch({
			type: types.DELETE_AGREEMENT_ERROR,
			payload: checkFetchErrors(error)
		});
	}
};

// ******************** SET SEARCH QUERY ********************
export const setAgreementsQuery = (query) => ({
	type: types.SET_AGREEMENTS_SEARCH_QUERY,
	payload: query
});
